import { render, staticRenderFns } from "./IndicatorsSelection.vue?vue&type=template&id=2fd5e46f&scoped=true"
import script from "./IndicatorsSelection.vue?vue&type=script&lang=js"
export * from "./IndicatorsSelection.vue?vue&type=script&lang=js"
import style0 from "./IndicatorsSelection.vue?vue&type=style&index=0&id=2fd5e46f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd5e46f",
  null
  
)

export default component.exports